import type { Units } from '../domain/units';
import { el } from './dom';

const OPTIONS: Array<{ units: Units; label: string; description: string }> = [
  { units: 'imperial', label: 'mi', description: 'Miles and feet' },
  { units: 'metric', label: 'km', description: 'Kilometres and metres' },
];

/**
 * Two buttons rather than the `role="switch"` used for the question mode.
 *
 * A switch has an off state, and neither unit system is the absence of the other -
 * labelling one "off" would be arbitrary. Two pressed-state buttons name both choices
 * and say which is live, which is what `aria-pressed` is for.
 */
export function unitsToggle(current: Units, onChange: (units: Units) => void): HTMLElement {
  return el(
    'div',
    { class: 'units', role: 'group', 'aria-label': 'Distance units' },
    ...OPTIONS.map((option) =>
      el(
        'button',
        {
          class: 'units__option',
          type: 'button',
          'aria-pressed': String(option.units === current),
          'aria-label': option.description,
          onclick: () => {
            if (option.units !== current) onChange(option.units);
          },
        },
        option.label,
      ),
    ),
  );
}
